import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchObtenerSubcategoria = async(id) => {
    try {
        const response = await axios.get(`${API_URL}/api/convocatoria/obtenerSubcategoria/${id}`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchSubcategoriaConvocatoriaFilters = async (paginaActual, registrosPorPag,busqueda,numCategorias, ordenarColumna, orden) => {
    
    try {
        const response = await axios.post(`${API_URL}/api/convocatoria/subcategorias/filters`, {

            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "numCategorias": numCategorias,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});


        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearSubcategoria = async (formData) => {
    console.log("formData", formData);
    try {
        const response = await axios.post(`${API_URL}/api/convocatoria/crearSubcategoria`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });

        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEditarSubcategoria = async (formData) => {
    console.log("formData", formData);
    try {
        const response = await axios.put(`${API_URL}/api/convocatoria/editarSubcategoria/${formData.IdSubcategoria}`, formData, {

            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }

        });

        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchActualizarSubcategorias = async (ids,campoValor) => {
    console.log("campoValor",campoValor);
    try {
        const response = await axios.post(`${API_URL}/api/convocatoria/actualizarSubcategoriasEnCadena`, {
            ids: ids,
            campo: campoValor.atributo,
            valor: campoValor.valor
        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};
